

var contextmenu = {
  data() {
    return {
        trIndex:0
      }
  },
  methods: {
    showContextMenu(e) {
      var target = e.target;

     
      const menu = document.getElementById('menu');
      const ele = document.getElementById('vgt-table'); 
    
      if (target.tagName === "TD" || target.tagName === "SPAN" ) {
        
        if (target.tagName === "SPAN") {
          var row = target.parentElement.parentElement;
          var rowIndex = row.rowIndex;
         
        } else {
           row = target.parentElement;
           rowIndex = row.rowIndex;
        }
     
      
        var thead = ele.querySelector("thead");
        var trElements = thead.querySelectorAll("tr");
        var trCount = trElements.length;
      
        this.trIndex = rowIndex - trCount
        
     
      } 
      e.preventDefault();

      const rect = ele.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Set the position for the menu
      menu.style.top = `${y}px`;
      menu.style.left = `${x}px`;

      var currentRow = ele.getElementsByTagName("tbody")[0].getElementsByTagName("tr")[this.trIndex];
      currentRow.style.backgroundColor = "transparent";

     
      menu.classList.remove('hidden');
      document.addEventListener('click', this.documentClickHandler);
    },
    documentClickHandler(e) {
      const menu = document.getElementById('menu');
        const isClickedOutside = !menu.contains(e.target);
        if (isClickedOutside) {
            menu.classList.add('hidden');
            document.removeEventListener('click', this.documentClickHandler);
        }
    },
  },
}

export default contextmenu